import { useEffect } from 'react';
import { useAuthStore } from '@shared/state';
import { runSystemDiagnostic } from '@shared/services/systemDiagnostic';
import { useDiagnosticStore } from './diagnosticStore';

// Headless component. Runs runSystemDiagnostic once per login and stores the
// result. Mount this at the top of the tree alongside AnalyticsTracker.
export function SystemDiagnosticRunner() {
  const user = useAuthStore((s) => s.user);
  const setResult = useDiagnosticStore((s) => s.setResult);
  const lastRunForUserId = useDiagnosticStore((s) => s.lastRunForUserId);

  useEffect(() => {
    if (!user?.uid) return;
    if (lastRunForUserId === user.uid) return;

    let cancelled = false;
    runSystemDiagnostic(user.uid)
      .then((result) => {
        if (cancelled) return;
        setResult(result, user.uid);
        if (result.status !== 'healthy') {
          console.log('systemDiagnostic:', result.status, result.checks);
        }
      })
      .catch((err) => {
        console.error('systemDiagnostic failed:', err);
      });

    return () => {
      cancelled = true;
    };
  }, [user?.uid, lastRunForUserId, setResult]);

  return null;
}
